import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { MpCommonActions } from "../../actions/mp-common.actions";
import { LaunchSiteState } from "../../models/mp-common/launch-site.state";

const initialState: LaunchSiteState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(MpCommonActions.launchSites.getApi, (state) => ({ ...state, loading: true })),
	on(MpCommonActions.launchSites.getSuccess, (state, action) => ({
		..._.omit(state, "error"),
		..._.omit(action, "type")
	})),
	on(MpCommonActions.launchSites.getFail, (state, action) => ({
		...state,
		..._.omit(action, "type")
	}))
);

export function launchSiteReducer(
	state: LaunchSiteState | undefined,
	action: Action
): LaunchSiteState {
	return reducer(state, action);
}
